import { render, staticRenderFns } from "./CardComponentContent.vue?vue&type=template&id=2c0cebea&scoped=true&"
import script from "./CardComponentContent.vue?vue&type=script&lang=js&"
export * from "./CardComponentContent.vue?vue&type=script&lang=js&"
import style0 from "./CardComponentContent.vue?vue&type=style&index=0&id=2c0cebea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0cebea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardActions,VChip,VIcon,VListItem,VListItemAvatar,VListItemContent,VListItemSubtitle,VSpacer})
